import { render, staticRenderFns } from "./SSOAuthorizeView.vue?vue&type=template&id=3afd809c&scoped=true"
import script from "./SSOAuthorizeView.vue?vue&type=script&lang=js"
export * from "./SSOAuthorizeView.vue?vue&type=script&lang=js"
import style0 from "./SSOAuthorizeView.vue?vue&type=style&index=0&id=3afd809c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd809c",
  null
  
)

export default component.exports